import React from "react";
import "./Section3.css";
import SideImage from "../../../../../assets/images/taxreturnssec3-img1.png";
import Tick from "../../../../../assets/images/list-tick.png";
const Section3 = () => {
  return (
    <div className="taxreturnssrs3__section">
      <div className="taxreturnssrs3__section_left">
        <div className="taxreturnssrs3__secleft_heading">
          We ensure that your returns don’t miss out the deductions
        </div>
        <div className="taxreturnssrs3__list_items">
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              We ensure that your returns don’t miss out the deductions, credits
              that you are eligible
            </div>
          </div>
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              Your tax return can be filed electronically so you will get a
              refund back quicker.
            </div>
          </div>
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              Our staff will show you how to adjust your payroll withholding to
              get more money back.
            </div>
          </div>
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              Resident Tax Returns – 1040, 1040A, 1040-EZ
            </div>
          </div>
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              Non-Resident Tax Returns – 1040NR, 1040NR-EZ
            </div>
          </div>
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              Amended Tax Return – 1040X
            </div>
          </div>
          <div className="taxreturnssrs3__list_item">
            <img className="taxreturnssrs3__list_item_icon" src={Tick} alt="" />
            <div className="taxreturnssrs3__list_item_right">
              Tax return Preparation – State, City & Local
            </div>
          </div>
        </div>
      </div>
      <div className="taxreturnssrs3__section_right">
        <img src={SideImage} alt="" className="taxreturnssrs3__section_img" />
      </div>
    </div>
  );
};

export default Section3;
